import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { FeatureService } from '../services/feature.service';

/**
 * FeatureGuard — blocks routes whose feature flag is disabled for the
 * current tenant. Attach via:
 *
 *   { path: 'reports', canActivate: [FeatureGuard], data: { feature: 'analytics.accounting' }, ... }
 *
 * Routes without a `data.feature` value are allowed through.
 */
@Injectable({ providedIn: 'root' })
export class FeatureGuard implements CanActivate {

  constructor(
    private features: FeatureService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const key = route.data && route.data['feature'];

    if (!key) {
      return true;
    }

    if (this.features.has(key)) {
      return true;
    }

    this.router.navigate(['/']);
    return false;
  }
}
